import httpClient from '../httpClient';

export async function getAllFiscaisPorEntidade(tab: string, id: number) {
  try {
    const response = await httpClient.get(`/api/fiscalaquisicao/porentidade`, {
      params: {
        tab,
        id,
      },
    });
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}
